const TrashIcon = (): JSX.Element => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.3333 6.33203L4 6.33204"
        stroke="#EB5545"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6641 11.332V17.9987"
        stroke="#EB5545"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6641 11.332V17.9987"
        stroke="#EB5545"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6641 6.33203V22.1654C20.6641 22.3864 20.5763 22.5983 20.42 22.7546C20.2637 22.9109 20.0517 22.9987 19.8307 22.9987H6.4974C6.27638 22.9987 6.06442 22.9109 5.90814 22.7546C5.75186 22.5983 5.66406 22.3864 5.66406 22.1654V6.33203"
        stroke="#EB5545"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3333 6.33333V4.66667C17.3333 4.22464 17.1577 3.80072 16.8452 3.48816C16.5326 3.17559 16.1087 3 15.6667 3H10.6667C10.2246 3 9.80072 3.17559 9.48816 3.48816C9.1756 3.80072 9 4.22464 9 4.66667V6.33333"
        stroke="#EB5545"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon;
